import { ManagementFocus } from '@root/api';

/* The six foci, in the order the company reads them (narrowest to widest scope). */
export const FOCUS_ORDER: ManagementFocus[] = [
    ManagementFocus.TeamLead,
    ManagementFocus.ManagerOfManagers,
    ManagementFocus.Executive,
    ManagementFocus.PeopleAdvisor,
    ManagementFocus.PeopleExecutive,
    ManagementFocus.AccountAdmin
];

/* What a company can set on a manager or admin: the six foci, plus GENERIC when it doesn't know theirs yet.
 * GENERIC gets an approximate report from their place in the org chart until the person chooses a focus. */
export const ASSIGNABLE_FOCUS_ORDER: ManagementFocus[] = [...FOCUS_ORDER, ManagementFocus.Generic];

export const focusNameKey = (focus: ManagementFocus) => `FOCUS_ROLES_FOCUS_${focus}`;
export const focusDescriptionKey = (focus: ManagementFocus) => `FOCUS_ROLES_FOCUS_${focus}_DESCRIPTION`;
/* When the focus is the usual pick, shown under its description in the focus select. */
export const focusRecommendationKey = (focus: ManagementFocus) => `FOCUS_ROLES_FOCUS_${focus}_RECOMMENDED`;

/* Last day for companies to confirm their focus draft; after it Happyforce applies unconfirmed drafts. */
export const FOCUS_CONFIRM_DEADLINE = '2026-11-15';

/* Managers and admins can't be saved without a focus (backend: MANAGER_OR_ADMIN_NEEDS_A_FOCUS). */
export const needsManagementFocus = (person: { role?: string; managementFocus?: string }) =>
    (person.role === 'MANAGER' || person.role === 'ADMIN') && !ASSIGNABLE_FOCUS_ORDER.includes(person.managementFocus as ManagementFocus);
